// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CopyLinkController from "./copy_link_controller";
application.register("copy-link", CopyLinkController);

import GroupTopicSelectController from "./group_topic_select_controller";
application.register("group-topic-select", GroupTopicSelectController);

import SnippetsPlayerController from "./snippets_player_controller";
application.register("snippets-player", SnippetsPlayerController);
